import "../styles/contact.css";

function ContactIcon({ type }) {
  const paths = {
    phone: "M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.8 2.1Z",
    mail: "M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z M22 6l-10 7L2 6",
    clock: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z M12 6v6l4 2",
  };
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[type]} /></svg>;
}

export default function Contact({ t }) {
  const copy = t.contactDetails;
  return (
    <section id="contact" className="contact-panel-section" aria-labelledby="contact-heading">
      <div className="contact-panel">
        <div className="contact-panel-intro">
          <p className="contact-panel-label">{t.contactTitle}</p>
          <h2 id="contact-heading">{copy.title}</h2>
          <p className="contact-panel-description">{copy.description}</p>
          <div className="contact-panel-signature"><span aria-hidden="true" />Eastlog <span className="contact-panel-signature-detail">Transport & Logistics</span></div>
        </div>
        <div className="contact-panel-methods">
          <div className="contact-method">
            <span className="contact-method-icon"><ContactIcon type="phone" /></span>
            <div className="contact-method-info"><h3>{t.phone}</h3><a href="tel:+48818867824">+48 81 886 78 24</a></div>
            <a className="contact-action" href="tel:+48818867824">{copy.call}<span aria-hidden="true">↗</span></a>
          </div>
          <div className="contact-method">
            <span className="contact-method-icon"><ContactIcon type="mail" /></span>
            <div className="contact-method-info"><h3>{t.email}</h3><a href="mailto:office@eastlog.com.pl">office@eastlog.com.pl</a></div>
            <a className="contact-action" href="mailto:office@eastlog.com.pl">{copy.write}<span aria-hidden="true">↗</span></a>
          </div>
          <div className="contact-office-hours">
            <ContactIcon type="clock" />
            <div><h3>{copy.hoursTitle}</h3><p>{copy.days}<span aria-hidden="true"> · </span><strong>8:00–16:00</strong></p></div>
          </div>
        </div>
      </div>
    </section>
  );
}